module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Marshmallows")]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('p', [_c('b', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('dl', [_c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01"
    }
  }, [_vm._v("Acknowledgements ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02"
    }
  }, [_vm._v("Introduction ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch03"
    }
  }, [_vm._v("Discovering Marshmallows and Where They Came From")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04"
    }
  }, [_vm._v("Learning about Equipment")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch05"
    }
  }, [_vm._v("Learning about Ingredients")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Marshmallows in High Altitudes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Using Tips and Techniques")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Basic Marshmallows ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#msyrup",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marshmallow Syrup")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#bcoat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Marshmallow Coating")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e519",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Your First Batch of Marshmallows ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#vmarsh",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanilla Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e598",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Chip Marshmallows ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e602",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dulce de Leche Marshmallows ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e608",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honey Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e646",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Molasses Marshmallows")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Marshmallows with Fruit Purees")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e699",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raspberry–Crème de Cassis Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e751",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e788",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Potato Spice Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#strawberry",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberry Marshmallows")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flavoring Marshmallows with Juices and Other Liquids")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#apple",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e949",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e991",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e1036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mango Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e1072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toasted Coconut Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e1129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honey Pear Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e1176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Key Lime Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e1219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Margarita Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e1261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#champm",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Champagne Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e1340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amaretto Marshmallows")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Infusing Marshmallows with Spices and Herbs ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e1398",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Spice Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#cinn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cinnamon Mocha Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e1509",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sauvignon Blanc–Long Pepper Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e1553",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon, Honey, and Cardamom Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e1599",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honey-Lavender Marshmallows")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flavoring Marshmallows in Additional Ways ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#cmarsh",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Marshmallows ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e1743",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramel Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e1798",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mint Julep Marshmallows")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Homemade Marshmallow Fluff ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#vanilla",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanilla Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e1952",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e1995",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blackberry Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e2044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meyer Lemon and Thyme Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#esp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Espresso Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e2136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butterscotch Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#cherry",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cherry Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e2220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange Flower Water Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e2261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Minted Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#grape",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Concord Grape Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e2358",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Cinnamon Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#banana",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#star",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honey–Star Anise Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e2515",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blood Orange, Rosemary, and Zinfandel Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e2562",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lime-Cilantro Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e2604",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e2656",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frozen Chocolate Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#dwfluff",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dessert Wine Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e2754",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frozen Pumpkin-Spice Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e2800",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green Tea and 5-Spice Fluff")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Using Homemade Marshmallows and Fluffs ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e2866",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S’mores")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e2917",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Cupcake Snowballs")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#cupcakes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dark Chocolate Cupcakes")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e2992",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rocky Road Brownies")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#brownies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eileen’s Deep Chocolate Brownies")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e3065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dessert Pizza ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#crtreats",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crispy Rice Treats ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e3141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homemade Mallowmars")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e3172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate-Espresso Whoopie Pies")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e3215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marshmallow Fluff Fudge")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#pbj",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PB & J Parfait")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e3290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Triple-Treat Brownies")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e3345",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramel Apple Treats")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e3371",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Cream Pie")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e3395",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberry Shortcake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#bcpie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana Cream Pie or Tartlets")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#crust",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eileen’s All-Butter Pastry Crust")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#pastryc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pastry Cream")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e3544",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Neapolitan Chocolate Fondue")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e3596",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange Crepes with Honey–Star Anise Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e3664",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate-Covered Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e3704",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Alaska")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e3759",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poached Pears with Dessert Wine Fluff")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e3797",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dan’s Champagne Marshmallow Wedding Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e3863",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hot Chocolate with Cinnamon Mocha Marshmallows")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e3885",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Cherry Cake Towers")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Doing Fun and Funky Things with Homemade Marshmallows ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e3935",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fluff and Chocolate-Dipped Strawberries")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e3955",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crispy Rice Treats to Go")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e3997",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Have a Marshmallow Decorating Party!")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e4045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wedding Shower Favors")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e4087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dice")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e4109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chick Peepers")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e4136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Favorite Cone Treats")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metric Conversion Chart")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-425e16fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bk01toc.vue
// module id = 63
// module chunks = 0